import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Loader2, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { authApi } from '@/lib/api/endpoints';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch {
      setSent(true); // risposta uniforme anche in caso di errore (no enumeration)
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center gap-2 mb-2"><Mail className="h-6 w-6 text-primary" /><span className="font-bold text-lg">Blagomail</span></div>
          <CardTitle>Password dimenticata</CardTitle>
          <CardDescription>Inserisci la tua email: ti invieremo un link per reimpostarla.</CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4 text-center">
              <CheckCircle2 className="h-12 w-12 text-emerald-500 mx-auto" />
              <p className="text-sm">Se esiste un account con quell'email, riceverai a breve un link per reimpostare la password (valido 1 ora). Controlla anche lo spam.</p>
              <Link to="/login" className="text-primary hover:underline text-sm font-medium">Torna al login</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" placeholder="tu@azienda.it" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
              </div>
              <Button type="submit" className="w-full" disabled={loading || !email}>
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Invia link di reset
              </Button>
              <p className="text-sm text-muted-foreground text-center">
                <Link to="/login" className="text-primary hover:underline">Torna al login</Link>
              </p>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
